module.exports = __webpack_public_path__ + "static/media/HouseHover.13d69ee6.svg";